import {EmbalajeActionTypes, EmbalajeState, LOAD_EMBALAJES_SUCCESS} from "../types/embalajeActionTypes";
import useCommonApi from "../../api/useCommonApi";

const apiSource = useCommonApi();

function loadEmbalajesSuccess(embalajes: EmbalajeState[]): EmbalajeActionTypes {
    return {
        type: LOAD_EMBALAJES_SUCCESS,
        embalajes
    }
}

export function loadEmbalajes() {
    return function (dispatch) {
        return apiSource.obtener<EmbalajeState[]>("embalaje/active")
            .then((embalajes: EmbalajeState[]) => {
                dispatch(loadEmbalajesSuccess(embalajes))
            })
            .catch(error => {
                throw error;
            })
    }
}
